import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';

import { getOnboarding } from '../api/endpoints/onboarding';
import type { BusinessDetail } from '../api/schemas';
import { EmptyState } from '../components/EmptyState';
import { LoadingState } from '../components/LoadingState';
import { PageHeader } from '../components/PageHeader';
import { ReservationLinkBuilder } from '../components/ReservationLinkBuilder';
import { useBusiness } from '../lib/useBusiness';
import '../styles/enlace-reserva.css';

/**
 * "Enlace de reserva": a customer writes on WhatsApp, the owner picks the
 * service and a free time here, and sends the link back. The customer opens
 * it in Dale with everything chosen and only confirms with their number.
 * The same builder also lives in place on Inicio (ReservationLinkCard).
 */
export function EnlaceReservaPage() {
  const business = useBusiness();
  if (!business) return <LoadingState label="Cargando tu negocio…" />;
  return <LinkPage business={business} />;
}

function LinkPage({ business }: { business: BusinessDetail }) {
  const onboarding = useQuery({ queryKey: ['business-onboarding'], queryFn: getOnboarding });

  if (business.services.length === 0) {
    return (
      <main>
        <PageHeader title="Enlace de reserva" />
        <EmptyState title="Primero agrega un servicio." description="El enlace lleva el servicio y la hora que acuerdas con tu cliente." />
        <Link to="/servicios" className="btn">
          Agregar servicio
        </Link>
      </main>
    );
  }

  return (
    <main className="enlace">
      <PageHeader
        title="Enlace de reserva"
        description="Elige el servicio y la hora que acordaste por WhatsApp. Tu cliente abre el enlace y confirma con su número."
      />
      {onboarding.data?.state === 'draft' ? (
        <p className="notice" role="status">
          Tu negocio todavía no está publicado. El enlace abre cuando lo publiques desde <Link to="/primer-dia">Primer día</Link>.
        </p>
      ) : null}
      <ReservationLinkBuilder business={business} />
    </main>
  );
}
